import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from '../../../_helpers/utility';
import { CountryService } from '../../country/service/country.service';
import { StateService } from '../../state/service/state.service';
import { CityService } from '../../city/service/city.service';
import { ClubService } from 'src/app/services/club.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-club-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    providers: [ConfirmationService, MessageService]
})

export class ClubEditComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    clubForm: FormGroup;
    errorMessage = '';
    submitted = false;
    uploadedFiles: any[] = [];
    file: File;
    countryList: any = [];
    stateList: any = [];
    cityList: any = [];
    rolelist: any = [];
    reader: FileReader;
    public profilepic;
    userRoleId;
    statuses: any = [];
    genders: any = [];
    clubStatus: any;
    usergender: any;
    countryname;
    countrycode;
    statename;
    statecode;
    cityname;
    citycode;
    dob: Date;
    minYear = environment.minYear;
    yearRange;
    public firstRankingSportList: any[];
    public typeArr: any[];
    public countriesList: any[] = [];
    public totalCountries;
    public firstRankingSport;
    public type;
    public countries;
    public states;
    public stateId;
    public countryId;
    public id;
    public item;
    constructor( private formBuilder: FormBuilder, private messageService: MessageService, private countryService: CountryService, private clubService: ClubService,
        private stateService: StateService, private cityService: CityService, private activateRoute: ActivatedRoute,
        private router: Router) { }

    ngOnInit(): void {
        this.id = this.activateRoute.snapshot.params.id;
        this.yearRange = this.minYear + ":" + maxYearFunction();
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.firstRankingSportList = [
            { id: '1', name: 'Tennis', value: 'T' },
        ];
        this.typeArr = [
            { id: '1', name: 'Club', value: 'club' },
        ];
        this.genders = [
            { name: 'Male', code: 'Male' },
            { name: 'Female', code: 'Female' },
            { name: 'Other', code: 'Other' },
        ];
        this.clubStatus = true;
        this.clubForm = this.formBuilder.group({
            name: ['', [Validators.required, Validators.pattern("([a-zA-Z',.-]+( [a-zA-Z',.-]+)*){2,30}")]],
            firstRanking: ['', [Validators.required, Validators.pattern("([a-zA-Z',.-]+( [a-zA-Z',.-]+)*){2,30}")]],
            // firstRankingSport: ['', Validators.required],
            type: ['', Validators.required],
            status: [{ label: 'Active', value: true }, Validators.required],
            disable: [false],
            country: [''],
            state: [''],
            city: [''],
            address: [''],
            zipcode: [''],

        });
        // this.getRoleid();
        this.getCountry();
        this.getClubDetails(this.id);
        // let query = "filterByDisable=false&filterByStatus=true";
        // this.roleService.getRoleList(query).subscribe(
        //     dataRole => {
        //         dataRole.data.items.forEach((elem, index) => {
        //             let roleObj = {
        //                 label: elem.user_role_name,
        //                 value: elem.id
        //             };
        //             this.rolelist.push(roleObj);
        //         });
        //     });

    }

    // convenience getter for easy access to form fields
    get f() {
        return this.clubForm.controls;
    }

    getClubDetails(id) {
        this.clubService.getClubDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            async data => {
                this.item = data;
                if (this.item) {
                    this.clubForm.patchValue({
                        name: this.item['name'],
                        firstRanking: this.item['firstRanking'],
                        address: this.item['address'],
                        zipcode: this.item['zipcode'],
                    });

                    if (this.item['type']) {
                        this.clubForm.get('type').setValue(this.item['type']);
                    }

                    if (this.item['countrycode']) {
                        this.clubForm.get('country').setValue(this.item['countrycode']);
                        this.getStates(this.item['countrycode']);
                        this.countrycode = this.item['countrycode'];
                    }
                    if (this.item['statecode']) {
                        this.clubForm.get('state').setValue({ "name": this.item['statename'], "id": this.item['statecode'] });
                        this.statecode = this.item['statecode'];
                        this.getCities(this.item['statecode']);
                        if (this.item['citycode']) {
                            console.log(this.item);
                            this.clubForm.get('city').setValue({ "name": this.item['cityname'], "id": this.item['citycode'] });
                            this.citycode = this.item['citycode'];
                            this.cityname = this.item['cityname'];
                        }


                    }

                    this.clubForm.controls.status.setValue(this.item['status']);
                }
                this.clubForm.get('name').disable();
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    // picUploader(event) {
    //     for (let file of event.files) {
    //         this.uploadedFiles.push(file);
    //         let reader = new FileReader();
    //         reader.readAsDataURL(this.uploadedFiles[0]);
    //         reader.onload = () => { // called once readAsDataURL is completed
    //             this.profilepic = reader.result;
    //         }
    //     }
    // }

    // getRoleid() {
    //     let querystring = "filterByroleName=admin";
    //     this.roleService.searchRoleDetails(querystring).subscribe(
    //         data => {
    //             this.userRoleId = data.data.items[0]['id'];
    //         },
    //         err => {
    //             this.errorMessage = err.error.message;
    //         }
    //     );
    // }

    getCountry() {
        let query = "";
        this.countryService.getcountryList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.countries = res.data.items;
            this.countries.forEach(element => {
                this.countriesList.push({ "name": element.name, "id": element._id, code: element.iso2 });
            })
        })
    }
    getStates(countryId) {
        let query = "filterByCountryCode=IN&filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1";
        this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.stateList = [];
            //this.states = res;      
            this.states = res.data.items;

            this.states.forEach(element => {
                this.stateList.push({ "name": element.name, "id": element.id });
                if (this.stateId == element._id) {
                    let stateSetObj = { "name": element.name, "id": element.id };
                    this.clubForm.controls.state.setValue(stateSetObj);

                }
            })
        })
    }
    setCountry(event) {
        this.countryId = event.value.id;
        this.countrycode = "IN";
        this.getStates(this.countryId);
    }
    setState(event) {
        this.stateId = event.value.id;
        this.statename = event.value.name;
        this.getCities(this.stateId);
    }
    async getCities(stateId) {
        let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateId;
        this.cityService.getcityList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
            //this.cityList = res.data.items;
            if (res.data.items.length > 0) {
                res.data.items.forEach(element => {
                    let cityObj = { "name": element.name, "id": element.id };
                    this.cityList.push(cityObj);
                });


                this.cityList.forEach(element => {
                    let cityObj = { "name": element.name, "id": element.id };
                    if (this.citycode == element.id) {
                        this.clubForm.get('city').setValue(cityObj);

                    }
                    this.cityList.push(cityObj);
                });
            }
        })
    }
    onClickFirstRankingSport(event) {
        this.firstRankingSport = event.value;
    }
    onClickType(event) {
        this.type = event.value;
    }
    onStatusSelect(event) {
        if (event) {
            this.clubStatus = event.value;
        }
    }

    onGenderSelect(event) {
        if (event) {
            this.usergender = event.name;
        }
    }

    onCitySelect(event) {
        console.log(event);
        this.cityname = event.value.name;
        this.citycode = event.value.id;
    }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.clubForm.invalid) {
            return;
        }
        let clubData = this.clubForm.value;
        clubData['disable'] = false;
        clubData['status'] = this.clubStatus;
        clubData['gender'] = this.usergender;
        clubData['countrycode'] = this.countrycode;
        clubData['countryname'] = this.countryname;
        clubData['statecode'] = this.stateId;
        clubData['statename'] = this.statename;
        clubData['citycode'] = this.citycode;
        clubData['cityname'] = this.cityname;
        delete clubData['city'];
        delete clubData['country'];
        delete clubData['state'];
        //display form values on success
        console.log(JSON.stringify(this.clubForm.value, null, 4));
        clubData = JSON.stringify(clubData, null, 4);

        this.clubService.updateClub(this.id, clubData).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Club Added', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/manage/club']);
                }, 2000);
            },
            ((err) => {
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Club failed', life: 6000 });
            })
        );
    }

    onReset() {
        this.submitted = false;
        this.clubForm.reset();
    }

    backLink() {
        this.router.navigate(['/manage/club']);
    }

    ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
